"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PickupPointsMapDetail = void 0;
var _mui = require("@ori-ui/mui");
var _culture = require("@ori/culture");
var _useDeliveryChannelAddressQuery = require("../../api/useDeliveryChannelAddressQuery");
var _useDeliveryChannelQuery = require("../../api/useDeliveryChannelQuery");
var _hooks = require("../../hooks");
var _models = require("../../models");
var _DeliveryBox = require("../DeliveryBox");
var _Skeleton = require("../Skeleton");
var _jsxRuntime = require("react/jsx-runtime");
const Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  alignItems: 'center',
  bottom: theme.spacing(4),
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  position: 'absolute',
  zIndex: 1000,
  width: '100%',
  pointerEvents: 'none'
}));
const customDeliveryBoxClass = 'map-delivery-box';
const StyledDeliveryBox = (0, _mui.styled)(_DeliveryBox.DeliveryBox)(({
  theme
}) => ({
  [`&.${customDeliveryBoxClass}`]: {
    margin: 0,
    maxWidth: `calc(100% - ${theme.spacing(3)})`,
    width: 400,
    pointerEvents: 'auto'
  }
}));
// TODO: Remove after flat selection UI is used in all markets
const PickupPointsMapDetail = ({
  selectedPickupPoint
}) => {
  const {
    isAddingNewDelivery
  } = (0, _hooks.useAnalytics)();
  const {
    deliveryChannelAddress,
    isDeliveryChannelAddressLoading
  } = (0, _useDeliveryChannelAddressQuery.useDeliveryChannelAddressQuery)(selectedPickupPoint.deliveryChannelId);
  const {
    deliveryChannel,
    isDeliveryChannelLoading
  } = (0, _useDeliveryChannelQuery.useDeliveryChannelQuery)(selectedPickupPoint.deliveryChannelId);
  const {
    city = '',
    streetAddress = '',
    zipcode: zipCode = ''
  } = deliveryChannelAddress ?? {};
  const {
    culture,
    timeZone
  } = (0, _culture.useCulture)();
  const estimatedDelivery = selectedPickupPoint.estimatedDelivery instanceof Date ? (0, _culture.formatDate)(selectedPickupPoint.estimatedDelivery, _culture.DateFormat.ShortDate, culture, timeZone) : '';
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Root, {
    children: isDeliveryChannelAddressLoading || isDeliveryChannelLoading ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Skeleton.DeliveryBoxSkeleton, {
      isAdditionalInfoVisible: true,
      isConfirmationButtonVisible: true
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledDeliveryBox, {
      isActive: true,
      isButtonConfirmationEnabled: true,
      isShownOnMap: true,
      boxName: "map-pickup-point-item",
      className: customDeliveryBoxClass,
      deliveryItem: {
        hintMessages: [],
        isDefault: false,
        isLastUsed: false,
        isPrimaryAddress: false,
        telephoneNumber: '',
        ...selectedPickupPoint,
        estimatedDelivery,
        name: selectedPickupPoint.description ?? '',
        ...deliveryChannelAddress,
        city,
        streetAddress,
        zipCode,
        workingHours: deliveryChannel?.workingHours
      },
      metaHierarchy: [_models.MetaHierarchy.DeliverySelection, isAddingNewDelivery.current ? _models.MetaHierarchy.FirstSelection : _models.MetaHierarchy.EditSelection, _models.MetaHierarchy.New, _models.MetaHierarchy.PickUpPoint, _models.MetaHierarchy.MapSearch]
    })
  });
};
exports.PickupPointsMapDetail = PickupPointsMapDetail;